import React, { useState, useEffect } from 'react'
import { Page, Document, Image, StyleSheet, Font, View, Text } from '@react-pdf/renderer';

import bahijR from '../../assets/fonts/Bahij-Nazanin-Regular.ttf';
import bahijB from '../../assets/fonts/Bahij-Nazanin-Bold.ttf';
import amiriR from '../../assets/fonts/Amiri-Regular.ttf';

//import pageCover from '../../assets/images/page_cover.jpg'
import logo_h from '../../assets/images/logo_h.jpeg';
import scissors from '../../assets/images/scissors.png';
import Table from './Table';

export default function TariffPdf({ v }) {

    //const [union, setUnion] = useState(null)

    useEffect(() => {
        Font.register({ family: 'bahijR', src: bahijR });
        Font.register({ family: 'bahijB', src: bahijB });
        Font.register({ family: 'amiriR', src: amiriR });

    }, [])



    /*   const getUnion =async () =>{
          try {
              const res = await v.http.get('api/settings');
              console.log('Get union ', res);
              if(res.data.success){
                  const data = res?.data?.data;
                  setUnion(data);

              }
          } catch (error) {
                  console.log( "Union fetch error ", error);
          }
      }

      useEffect(() => {
          if(union === null)
          getUnion()
      }, []) */

      function addSpaceBetweenStringAndNumber(str) {
        return str.replace(/([a-zA-Z\u0600-\u06FF])(\d)/, '$1 $2');
    }

      const cn1 =(str) =>{
          console.log("string ...", str)
        const westernToArabic = {
            '0': '٠', '1': '١', '2': '٢', '3': '٣',
            '4': '٤', '5': '٥', '6': '٦', '7': '٧',
            '8': '٨', '9': '٩'
        };

        return str.split('').map(char => westernToArabic[char] || char).join('');
    }





    const cn = (n) => v?.com?.numConvertAndRevrse(n);
    const rd = (n) => v?.com?.reverseDigits(n)

    const splitText = (txt) => {
        const mText = getSplitText(txt)

        return <View style={{...styles1.flexRowReverse, ...styles.bahijB, borderRight: '0.5px solid gray', width: "75%", paddingRight: 10 }}>

            {mText.map((word, idx) => {
                return (
                    <Text style={styles1.ml1} key={idx}>
                      {word}
                    </Text>
                );
            })}
        </View>
    }


    /*  .slice(0).reverse() */
    const getMT = (l, v, afn = null, isLongText =false) =>
        <View style={styles.rightColText}>

            {isLongText? splitText(v):  <Text style={{ ...styles.bahijB, borderRight: '0.5px solid gray', width: "75%", paddingRight: 10 }}> {afn} {v} </Text>}
            <Text >{l}</Text>

        </View>

    const getSplitText = (t) => t ? t.split(" ") : []
//v.model?.company ? v.model?.company?.name_af : v.model?.name
    const getDetialCol = () => <View style={styles.tariffCol}>
        <View style={styles.rightColText}></View>
        {getMT(`تاريخ`, v?.com?.getShamshiDate(v.model?.updated_at))}
        {getMT(`شماره تعرفه`, cn((v.model?.row_number)?.toString()))}
        {getMT(`ای دی`, cn((v.model?.id)?.toString()))}
        {getMT(`اسم`,v.model?.company ? v.model?.company?.name_af : rd(v.model?.name) , null, false)}
        {getMT(`نام بانک`, v?.union?.bank_name)}
        {getMT(`حساب نمبر بانکی`, v?.model?.tariff_type.value!=96?cn("1001334030256"):cn("1001336095475"))}
        {/* Only for exports */}
        {/* {v?.model?.tariff_type?.value === 21 && getMT(`مصارف قرطاسيه`, cn('100'), '؋')}
        {getMT(`مبلغ قابل تاديه`, cn(v.model?.amount), '؋')} */}
    </View>

    const copy = (copy, header = true, footer = true) => {
        return (<View>
            {header && <View style={styles.header}>
                <Image style={styles.logo_h} src={logo_h} />  <Image allowDangerousPaths src={document.getElementById(v?.model?.id).toDataURL()} style={{ height: '80px', width: '80px', position: 'absolute', right: 0 }} />
                <Text style={styles.pageTitle}>معاونيت مالی و اداری</Text>
                <Text style={styles.pageTitle}>تعرفه بانکی</Text>
            </View>}

            <View style={styles.tariffOne}>
                <Text style={{ textAlign: 'left', width: '100%' }}>{copy}</Text>
                <View style={styles.divOne}>

                    <View style={styles.tariffCol}>
                        <Table v={{ items: v?.model?.items, com: v.com, amount: v?.model?.amount, tariffType: v?.model?.tariff_type }} />
                        {/*  <Text style={{ selfAlign: 'left', fontSize: 9 }}>{`نوت: مصارف قرطاسيه ${cn('100')} افغانی`}</Text> */}

                    </View>

                    {getDetialCol()}

                </View>

                <View style={[styles1.flexRowReverse]}>

                    {
                        getSplitText(`لصفاً ${v.Num2persian(v.model?.amount)} ${v?.model?.tariff_type.value!=96?'افغانی':'دالر امريکايی'} به حساب ${v?.model?.tariff_type.value!=96?cn("1001334030256"):cn("1001336095475")} ریاست اتحاديه مؤلدين و صادرکنندگان قالین افغانستان تحويل داده آويز اطمنان بخشيد.`).map((word, idx) => {
                            return (
                                <Text style={{ ...styles1.ml1 }} key={idx}>
                                    {word}
                                </Text>
                            );
                        })
                    }

                </View>



                {footer && <View style={{ display: "flex", flexDirection: 'row', marginTop: 60, marginBottom: 40, position: 'relative' }}>
                    <Text style={{ borderBottom: '0.7px dashed black', width: '100%', }}></Text>
                    <Image src={scissors} style={{ height: 15, top: 7, left: 3 }} />

                </View>}

            </View>
        </View>)
    }

    return (
        <> {v?.union && <Document>
            <Page size="A4" >
                <View style={styles.page}>
                    {copy('کاپي شرکت')}


                    {/*    {copy('کاپي اتحاديه', false)} */}

                    {copy('کاپي بانک', true, false)}
                </View>

            </Page>
        </Document>}</>
    )
}
const styles1 = StyleSheet.create({
    flexRowReverse: {
        flexDirection: "row-reverse",
        lineHeight: 1.5,
        flexWrap: "wrap",
        fontSize: 10

    },
    ml1: {
        marginLeft: "3pt",

    }
})

const styles = StyleSheet.create({
    page: {
        fontFamily: 'bahijR',
        fontSize: 11,
        textAlign: 'right',
        marginTop: 30,
        marginLeft: 30,
        marginRight: 30,
        lineHeight: 1.5,
    },
    logo_h: {
        height: 50,
        width: 220
    },
    header: {
        width: '100%',
        height: 90,
        display: 'flex',
        alignItems: 'center',
        alignSelf: 'center',
        /*    border: '1px solid black' */

    },
    pageTitle: {
        fontSize: 12, fontFamily: 'bahijB', color: '#851317'
    },
    tariffOne: {
        marginTop: 0,

    },
    divOne: {
        marginTop: 5,
        display: "flex",
        flexDirection: 'row',
        justifyContent: 'space-between',
        direction: 'rtl'
    },
    tariffCol: {
        width: 250, minHeight: 120,
        //border: "1px solid black"
    },

    rightColText: {
        display: 'flex', flexDirection: 'row', justifyContent: 'space-between',
        borderBottom: '0.5px solid gray',
        borderLeft: '0.5px solid gray',
        borderRight: '0.5px solid gray',
        fontSize: 10,
        paddingRight: 10,
        paddingLeft: 5,
    },

    logo: {
        height: 50,
        width: 200
    },

    bahijB: {
        fontFamily: 'bahijB',
    }
});
